/**
 * @ignore
 */
export const Ok = (value) => ({ ok: true, value });
/**
 * @ignore
 */
export const Err = (error) => ({ ok: false, error });
//# sourceMappingURL=result.js.map